import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhoneGradeComponent } from './phone-grade.component';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ng2-tooltip-directive';
import {
  MatInputModule, MatPaginatorModule, MatProgressSpinnerModule,
  MatSortModule, MatTableModule
} from "@angular/material";
import { UiSwitchModule } from 'ngx-ui-switch';


const routerConfig = [{
  path: '',
  component: PhoneGradeComponent
}];

@NgModule({
  imports: [
    CommonModule, FormsModule, TooltipModule,
    MatTableModule, MatSortModule, MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, ReactiveFormsModule,
    RouterModule.forChild(routerConfig),
    UiSwitchModule
  ],
  declarations: [
    PhoneGradeComponent
    //TruncatePipe
  ],
  exports: [
    PhoneGradeComponent, MatSortModule
  ],
  providers: []

})

export class PhoneGradeModule { }
